import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/AuthService';

/**
 * Доступ в /admin: авторизован И НЕ клиент.
 *
 * Принцип «есть хоть какой permission» был размытым: клиент без permissions
 * не пройдёт, но это работает по эффекту, а не по семантике. Явная проверка
 * «не клиент» точнее: если в будущем у клиента появятся какие-то client.*
 * permissions, неправильная логика начала бы пропускать его в /admin.
 *
 * Конкретные разделы внутри /admin защищены permissionGuard'ами по матрице.
 */
export const adminAuthGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }

  if (auth.hasRole('client') && !auth.isSuperAdmin()) {
    router.navigate(['/client']);
    return false;
  }

  return true;
};
